import {  Form, Modal } from 'antd';
import { useState, useEffect } from 'react';


const ReportDealModal = ({isModalOpen, setIsModalOpen, currentDeal , setCurrentDeal}) => {
 
  const [form] = Form.useForm();
  

  const [formData, setFormData] = useState({
   
  });



  
  useEffect(() => {
    form.setFieldsValue(formData);
  }, [formData, form]);

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const afterClose = () => {
    form.resetFields(); // Reset the form fields
    setFormData({})
    setCurrentDeal(null)
  };

  const styles = {
  body: {
    height: "80vh",
    maxHeight: "80vh",
    overflowY: "hidden",
  },
};
  return (
    <Modal
      centered
      styles={styles}
      footer={null}
      open={isModalOpen}
      onCancel={handleCancel}
      afterClose={afterClose}
      
    >

<div className='flex flex-col w-full h-full gap-14  '>
            <div className='flex flex-col'>
                <h2 className='font-semibold text-2xl text-center'>Signalement offre</h2>
            </div>

           {currentDeal && <div className=''>
                <h4 className='font-semibold'>Entreprise: <span className='font-normal'>{currentDeal.deal.company.name}</span></h4> 
                <h4 className='font-semibold'>Offre: <span className='font-normal'>{currentDeal.deal.offer}</span></h4> 
                <h4 className='font-semibold' >Signalé par: <span className='font-normal'>{currentDeal.user.fullname}</span></h4>
                <h4 className='font-semibold'>Message: <span className='font-normal'>{currentDeal.message}</span></h4> 

            </div>}

        </div>

    </Modal>
  );
};

export default ReportDealModal;
